(function () {
  'use strict';

  var rootSelector = '.article';
  var triggerSelector = '[data-arb-article-video-trigger]';

  function extractYouTubeId(src) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      if (url.hostname.includes('youtu.be')) return url.pathname.replace(/^\//, '').split('/')[0] || '';
      if (url.hostname.includes('youtube.com')) return url.searchParams.get('v') || url.pathname.split('/').pop() || '';
    } catch (error) {
      return '';
    }
    return '';
  }

  function buildEmbedSrc(youtubeId) {
    return 'https://www.youtube.com/embed/' + encodeURIComponent(youtubeId);
  }

  function buildPosterSrc(youtubeId) {
    return 'https://img.youtube.com/vi/' + encodeURIComponent(youtubeId) + '/maxresdefault.jpg';
  }

  function revealArticleHeaderImages(root) {
    root.querySelectorAll('.arb-article-header__photo').forEach(function (image) {
      if (image.dataset.arbArticleHeaderImageReady === 'true') return;
      image.dataset.arbArticleHeaderImageReady = 'true';

      function markReady() {
        image.classList.add('arb-article-header__photo--fade-ready');
        image.classList.remove('arb-article-header__photo--fade-pending');
      }

      if (image.complete && image.naturalWidth > 0) {
        markReady();
        return;
      }

      image.classList.add('arb-article-header__photo--fade-pending');
      image.addEventListener('load', markReady, { once: true });
      image.addEventListener('error', markReady, { once: true });
    });
  }

  function buildVideoBand(iframe) {
    var src = iframe.getAttribute('src') || '';
    var youtubeId = extractYouTubeId(src);
    if (!youtubeId) return null;

    var title = iframe.getAttribute('title') || 'Video';
    var band = document.createElement('div');
    band.className = 'arb-article-video-band';
    band.innerHTML =
      '<button type="button" class="arb-article-video-band__trigger" data-arb-article-video-trigger data-youtube-id="' +
      youtubeId +
      '" data-video-title="' +
      title.replace(/"/g, '&quot;') +
      '" aria-label="Play video">' +
      '<img class="arb-article-video-band__poster" src="' +
      buildPosterSrc(youtubeId) +
      '" alt="" width="1280" height="720" loading="lazy" decoding="async">' +
      '<span class="arb-article-video-band__play" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" focusable="false"><path d="M8 6.5v11L18 12 8 6.5Z" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"></path></svg>' +
      '</span>' +
      '</button>';

    var poster = band.querySelector('.arb-article-video-band__poster');
    if (poster) {
      poster.addEventListener('error', function onPosterError() {
        poster.removeEventListener('error', onPosterError);
        poster.src = 'https://img.youtube.com/vi/' + encodeURIComponent(youtubeId) + '/hqdefault.jpg';
      });
    }

    return band;
  }

  function upgradeYouTubeIframes(root) {
    root.querySelectorAll('.prose iframe[src*="youtube.com"], .prose iframe[src*="youtu.be"]').forEach(function (iframe) {
      var band = buildVideoBand(iframe);
      if (!band) return;
      var parent = iframe.parentElement;
      if (parent && parent.tagName === 'P' && parent.childElementCount === 1) {
        parent.replaceWith(band);
      } else {
        iframe.replaceWith(band);
      }
    });
  }

  function isStandaloneImageParagraph(paragraph) {
    if (!paragraph) return false;
    var meaningfulChildren = Array.prototype.filter.call(paragraph.children, function (child) {
      return child.tagName !== 'BR';
    });

    return meaningfulChildren.length === 1 && meaningfulChildren[0].tagName === 'IMG' && paragraph.textContent.trim() === '';
  }

  function upgradeStandaloneImageBanners(root) {
    root.querySelectorAll('.arb-story-article').forEach(function (article) {
      if (article.dataset.arbStandaloneImageBannerReady === 'true') return;

      var paragraphs = article.querySelectorAll('p');
      for (var i = 0; i < paragraphs.length; i++) {
        var paragraph = paragraphs[i];
        if (!isStandaloneImageParagraph(paragraph)) continue;

        var image = paragraph.querySelector('img');
        if (!image) continue;

        paragraph.classList.add('arb-article-inline-parallax-banner');
        paragraph.setAttribute('data-parallax', 'trigger');
        paragraph.setAttribute('data-parallax-start', '12');
        paragraph.setAttribute('data-parallax-end', '-12');
        image.classList.add('arb-article-inline-parallax-banner__image');
        image.setAttribute('data-parallax', 'target');
        article.dataset.arbStandaloneImageBannerReady = 'true';

        if (typeof window.arbInitParallaxBanners === 'function') {
          window.arbInitParallaxBanners();
        }
        break;
      }
    });
  }

  function getArticleGalleryLayout(gallery) {
    var layout = gallery.getAttribute('data-arbortech-story-gallery-layout') || gallery.getAttribute('data-layout') || '';
    if (layout) return layout;
    if (gallery.classList.contains('arb-article-image-display--inline')) return 'inline';
    if (gallery.classList.contains('arb-article-image-display--one')) return 'one';
    if (gallery.classList.contains('arb-article-image-display--two')) return 'two';
    if (gallery.classList.contains('arb-article-image-display--three')) return 'three';
    if (gallery.classList.contains('arb-article-image-display--carousel')) return 'carousel';

    return 'carousel';
  }

  /* arbt: article body carousels reuse the Osmo GSAP slider engine + card markup
     from sections/arb-image-carousel.liquid (the "our story" carousel) so every
     carousel on the site looks and behaves identically. Headerless by design. */
  function scheduleGsapSliderInit() {
    var attempts = 0;

    function tryInit() {
      attempts += 1;
      if (typeof window.initBasicGSAPSlider === 'function' &&
          typeof window.gsap !== 'undefined' &&
          typeof window.Draggable !== 'undefined' &&
          typeof window.InertiaPlugin !== 'undefined') {
        window.initBasicGSAPSlider();
        return;
      }
      if (attempts < 600) window.setTimeout(tryInit, 50);
    }

    tryInit();
  }

  var CAROUSEL_ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none" aria-hidden="true">' +
    '<path d="M6.28871 12L7.53907 10.9111L3.48697 6.77778H16.5V5.22222H3.48697L7.53907 1.08889L6.28871 0L0.5 6L6.28871 12Z" fill="currentColor"></path>' +
    '</svg>';

  /* arbt: the translated accessibility strings for an article-body carousel.
     sections/main-article.liquid renders this exact set onto the `.article` root
     (see the comment there); the carousel root is built here in the browser, so
     there is no Liquid on it to translate. Copying the whole set onto the built
     root also hands assets/arb-image-carousel.js — the shared Osmo slider engine,
     which re-injects the aria attributes on init — the same strings it gets from
     the arb-image-carousel SECTION. */
  var CAROUSEL_LABEL_ATTRS = [
    'data-carousel-label',
    'data-carousel-roledescription',
    'data-slider-label',
    'data-list-roledescription',
    'data-list-label',
    'data-slide-label',
    'data-slide-roledescription',
    'data-controls-label',
    'data-prev-label',
    'data-next-label'
  ];

  function copyCarouselLabels(source, target) {
    if (!source) return;
    CAROUSEL_LABEL_ATTRS.forEach(function (name) {
      var value = source.getAttribute(name);
      if (value) target.setAttribute(name, value);
    });
  }

  function buildCarouselControl(direction, label) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gsap-slider__control';
    button.setAttribute('data-gsap-slider-control', direction);
    /* The label is a translated string read back out of an attribute, so it goes in
       as text, not as markup. */
    var srLabel = document.createElement('span');
    srLabel.className = 'sr-only';
    srLabel.textContent = label;
    button.appendChild(srLabel);
    button.insertAdjacentHTML('beforeend', CAROUSEL_ARROW_SVG);
    return button;
  }

  function enhanceArticleGalleryCarousel(gallery, labelSource) {
    var figures = Array.prototype.filter.call(gallery.children, function (child) {
      return child.nodeType === 1;
    });
    if (figures.length === 0) return;

    /* arbt: opt-in variant emitted only by snippets/arbt-artist-story-blocks.liquid.
       Without the modifier the caption keeps being lifted into the overlay <div>
       every other carousel on the site uses, so blog galleries and the
       arb-image-carousel section are untouched. */
    var captionsBelow = gallery.classList.contains('arb-article-image-display--captions-below');

    var slider = document.createElement('div');
    var collection = document.createElement('div');
    var track = document.createElement('div');
    var controls = document.createElement('div');

    slider.className = 'gsap-slider arb-image-carousel__slider';
    slider.setAttribute('data-gsap-slider-init', '');
    slider.setAttribute('data-gsap-slider-loop', 'true');
    slider.setAttribute('data-gsap-slider-center', 'true');
    copyCarouselLabels(labelSource, slider);
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-roledescription', slider.getAttribute('data-carousel-roledescription') || 'carousel');
    slider.setAttribute('aria-label', slider.getAttribute('data-carousel-label') || 'Image carousel');
    collection.className = 'gsap-slider__collection';
    collection.setAttribute('data-gsap-slider-collection', '');
    track.className = 'gsap-slider__list';
    track.setAttribute('data-gsap-slider-list', '');
    controls.className = 'gsap-slider__controls';
    controls.setAttribute('data-gsap-slider-controls', '');
    controls.setAttribute('aria-label', slider.getAttribute('data-controls-label') || 'Carousel controls');

    figures.forEach(function (figure) {
      var item = document.createElement('div');
      var card = document.createElement('div');
      var media = document.createElement('div');
      var image = figure.querySelector('img, picture, video');
      var caption = figure.querySelector('figcaption');

      item.className = 'gsap-slider__item';
      item.setAttribute('data-gsap-slider-item', '');
      card.className = 'arb-carousel-slide';
      media.className = 'arb-carousel-slide__media';

      if (image) {
        image.classList.add('arb-carousel-slide__img');
        image.setAttribute('draggable', 'false');
        media.appendChild(image);
      }
      card.appendChild(media);

      if (captionsBelow) {
        /* Caption stays a real <figcaption>, so it needs a real <figure> to
           belong to — the slide card itself is a <div> the slider transforms. */
        var slideFigure = document.createElement('figure');
        slideFigure.className = 'arb-carousel-figure';
        slideFigure.appendChild(card);

        if (caption && caption.textContent.trim() !== '') {
          var belowCaption = document.createElement('figcaption');
          belowCaption.className = 'arb-carousel-figure__caption';
          while (caption.firstChild) belowCaption.appendChild(caption.firstChild);
          slideFigure.appendChild(belowCaption);
        }

        item.appendChild(slideFigure);
      } else {
        if (caption && caption.textContent.trim() !== '') {
          var captionWrap = document.createElement('div');
          var captionText = document.createElement('p');
          captionWrap.className = 'arb-carousel-slide__caption';
          captionText.className = 'arb-carousel-slide__caption-text';
          while (caption.firstChild) captionText.appendChild(caption.firstChild);
          captionWrap.appendChild(captionText);
          card.appendChild(captionWrap);
        }

        item.appendChild(card);
      }

      track.appendChild(item);
      figure.remove();
    });

    controls.appendChild(buildCarouselControl('prev', slider.getAttribute('data-prev-label') || 'Previous slide'));
    controls.appendChild(buildCarouselControl('next', slider.getAttribute('data-next-label') || 'Next slide'));
    collection.appendChild(track);
    slider.appendChild(collection);
    slider.appendChild(controls);
    gallery.appendChild(slider);
    scheduleGsapSliderInit();
  }

  function enhanceArticleImageDisplays(root) {
    root.querySelectorAll('.prose [data-arbortech-story-gallery], .prose .arb-article-image-display').forEach(function (gallery) {
      if (gallery.dataset.arbArticleImageDisplayReady === 'true') return;

      var layout = getArticleGalleryLayout(gallery);
      gallery.dataset.arbArticleImageDisplayReady = 'true';
      gallery.classList.add('arb-article-image-display');
      gallery.classList.add('arb-article-image-display--' + layout);
      gallery.setAttribute('data-arbortech-story-gallery-layout', layout);

      if (layout === 'carousel') enhanceArticleGalleryCarousel(gallery, root);
    });
  }


  /* WCAG 2.1.2 / 4.1.2 (FAIL-A2): the modal declares role="dialog"
     aria-modal="true", so Tab and Shift+Tab must cycle INSIDE it. Measured before
     this: the third Tab off the close button landed on a project card on the page
     behind the scrim — content the modal had already told a screen reader was
     inert. Lifted from assets/arb-product-gallery.js (L247-L271), which probe (k)
     verifies on both PDPs. One deliberate difference: `iframe` is in the selector
     here. The YouTube player is a real tab stop in this dialog and it is the only
     route to the provider's pause control, so leaving it out would cycle Tab over
     the two close buttons and make pause unreachable — a 2.2.2 defect introduced
     while fixing 2.1.2. The two video modals must stay identical to each other. */
  var MODAL_FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function trapModalTab(root, event) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll(MODAL_FOCUSABLE)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !root.contains(active)) {
        event.preventDefault();
        last.focus();
      }
      return;
    }

    if (active === last || !root.contains(active)) {
      event.preventDefault();
      first.focus();
    }
  }

  function initVideoModal(root) {
    var modal = root.querySelector('[data-arb-article-video-modal]');
    var iframe = root.querySelector('[data-arb-article-video-iframe]');
    var title = root.querySelector('[data-arb-article-video-title]');
    if (!modal || !iframe || !title) return;

    var lastTrigger = null;
    var closeButtons = root.querySelectorAll('[data-arb-article-video-close]');
    var titleVisual = title.querySelector('[data-arb-article-video-title-visual]');
    var titleAccessible = title.querySelector('[data-arb-article-video-title-accessible]');
    var titleAnimationFrame = 0;

    function stopTitleAnimation() {
      if (titleAnimationFrame) window.cancelAnimationFrame(titleAnimationFrame);
      titleAnimationFrame = 0;
      title.classList.remove('is-typing');
    }

    function setModalTitle(value) {
      var videoTitle = value || 'Video';
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      stopTitleAnimation();

      if (!titleVisual || !titleAccessible) {
        title.textContent = videoTitle;
        return;
      }

      titleAccessible.textContent = videoTitle;
      titleVisual.textContent = '';

      if (prefersReducedMotion) {
        titleVisual.textContent = videoTitle;
        return;
      }

      var characters = Array.from(videoTitle);
      var characterIndex = 0;
      var previousFrameTime = 0;
      title.classList.add('is-typing');

      function typeNextCharacter(frameTime) {
        if (!previousFrameTime || frameTime - previousFrameTime >= 32) {
          characterIndex += 1;
          titleVisual.textContent = characters.slice(0, characterIndex).join('');
          previousFrameTime = frameTime;
        }

        if (characterIndex >= characters.length) {
          titleAnimationFrame = 0;
          title.classList.remove('is-typing');
          return;
        }

        titleAnimationFrame = window.requestAnimationFrame(typeNextCharacter);
      }

      titleAnimationFrame = window.requestAnimationFrame(typeNextCharacter);
    }

    function closeModal() {
      stopTitleAnimation();
      iframe.src = '';
      iframe.title = '';
      if (titleVisual && titleAccessible) {
        titleVisual.textContent = '';
        titleAccessible.textContent = '';
      } else {
        title.textContent = '';
      }
      modal.hidden = true;
      document.body.classList.remove('arb-project-video-modal-open');
      if (lastTrigger instanceof HTMLElement) lastTrigger.focus();
    }

    function openModal(trigger) {
      var youtubeId = trigger.getAttribute('data-youtube-id');
      if (!youtubeId) return;

      var videoTitle = trigger.getAttribute('data-video-title') || 'Video';
      var embedSrc = buildEmbedSrc(youtubeId);
      lastTrigger = trigger;
      setModalTitle(videoTitle);
      iframe.title = videoTitle;
      iframe.src = embedSrc + '?autoplay=1&rel=0&modestbranding=1';
      modal.hidden = false;
      document.body.classList.add('arb-project-video-modal-open');

      /* The panel's close button, NOT the first [data-arb-article-video-close] in
         the modal — that is the full-viewport backdrop, which sits OUTSIDE the
         [aria-modal] panel, so a bare querySelector landed the opening focus on an
         element a modal-aware screen reader cannot reach. */
      var closeButton =
        modal.querySelector('[role="dialog"] [data-arb-article-video-close]')
        || modal.querySelector('[data-arb-article-video-close]');
      if (closeButton instanceof HTMLElement) closeButton.focus();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest(triggerSelector);
      if (trigger && root.contains(trigger)) {
        event.preventDefault();
        openModal(trigger);
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    /* The Tab handler alone cannot hold this dialog, and the reason is the
       player. Once focus is inside the cross-origin YouTube iframe, keydown
       fires in ITS document — the parent never sees it — so the browser walks
       focus straight out of the iframe into the page behind (measured: one leak
       to a footer social link). focusin DOES fire on the parent the moment focus
       lands on a parent-document element, so it is the only place that exit can
       be caught. Guarded on !modal.hidden, and on the target being outside the
       modal, so it never fights closeModal()'s own focus restore. */
    document.addEventListener('focusin', function (event) {
      if (modal.hidden) return;
      if (event.target instanceof Node && modal.contains(event.target)) return;
      var closeButton = modal.querySelector('[role="dialog"] [data-arb-article-video-close]');
      if (closeButton instanceof HTMLElement) closeButton.focus();
    });

    /* DOCUMENT-level, matching the gallery's reasoning: a handler bound to the
       modal only fires while focus is already inside it, so anything that parks
       focus on <body> (a backdrop click, the iframe load) kills the trap. Guarded
       on !modal.hidden so it costs nothing while closed. */
    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key === 'Tab') trapModalTab(modal, event);
    });
  }

  function upgradeProseCtaLinks(root) {
    root.querySelectorAll('.arb-article-body .prose p').forEach(function (paragraph) {
      if (paragraph.dataset.arbProseCtaReady === 'true') return;

      var strong = paragraph.querySelector(':scope > strong');
      if (!strong || paragraph.children.length !== 1) return;

      var link = strong.querySelector(':scope > a');
      if (!link || strong.childElementCount !== 1) return;
      if (paragraph.textContent.trim() !== link.textContent.trim()) return;

      paragraph.dataset.arbProseCtaReady = 'true';
      paragraph.classList.add('arb-article-prose-cta');

      link.classList.add('arb-button', 'arb-button--primary');
      link.removeAttribute('style');

      var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      arrow.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      arrow.setAttribute('width', '20');
      arrow.setAttribute('height', '20');
      arrow.setAttribute('viewBox', '0 0 24 24');
      arrow.setAttribute('fill', 'none');
      arrow.setAttribute('stroke', 'currentColor');
      arrow.setAttribute('stroke-width', '2');
      arrow.setAttribute('stroke-linecap', 'round');
      arrow.setAttribute('stroke-linejoin', 'round');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML = '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>';

      strong.replaceWith(link);
      link.appendChild(arrow);
    });

    if (typeof window.arbInitButton038 === 'function') window.arbInitButton038();
  }

  function initArticle(root) {
    if (!root || root.dataset.arbArticleReady === 'true') return;
    root.dataset.arbArticleReady = 'true';
    revealArticleHeaderImages(root);
    upgradeYouTubeIframes(root);
    upgradeStandaloneImageBanners(root);
    upgradeProseCtaLinks(root);
    enhanceArticleImageDisplays(root);
    initVideoModal(root);
  }

  function initAll(container) {
    (container || document).querySelectorAll(rootSelector).forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
